export default "__VITE_PUBLIC_ASSET__fa145955__"